import React from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import { usePageView } from '../hooks/useAnalytics'
import './gallery.css'

const Gallery = (props) => {
  // Track page view
  usePageView('Gallery');

  return (
    <div className="gallery-container">
      <Helmet>
        <title>Gallery - ORRAM Frames</title>
        <meta
          property="og:title"
          content="Gallery - ORRAM Frames"
        />
      </Helmet>
      <Navigation></Navigation>
    </div>
  )
}

export default Gallery
